const dateFilters = [
  'equals', 
  'inRange',
  'Before', 
  'Today', 
  'Today or After',
  'Next 7 Days',
  'This Week', 
  'Last Week', 
  'This Month', 
  'Last Month', 
  'This Year',
  'Last Year',
  'lessThan', 
  'lessThanOrEqual', 
  'greaterThan', 
  'greaterThanOrEqual'
];

const dateFixedFilters = [
  'Next 7 Days',
  'This Week', 
  'Last Week', 
  'This Month', 
  'Last Month', 
  'This Year',
  'Last Year',
];
export {dateFilters, dateFixedFilters};
